import React, {useState, useEffect} from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

interface BreadcrumbsNavigationItem {
  menuName?: string;
  menuAction?: string;
  search?: string; // To handle query params
  state?: Record<string, any>; // To persist state
}

interface BreadcrumbsNavigationProps {
  navigationItem?: BreadcrumbsNavigationItem[];
}
const LOCAL_STORAGE_KEY = "breadcrumbs";


const InjectionMouldingBreadcrumbs: React.FC<BreadcrumbsNavigationProps> = ({
  navigationItem,
}) => {

  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsNavigationItem[]>([]);
  const [lastBreadcrumb, setLastBreadcrumb] = useState<BreadcrumbsNavigationItem | null>(null);

  useEffect(() => {
    const storedBreadcrumbs = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (storedBreadcrumbs) {
      setBreadcrumbs(JSON.parse(storedBreadcrumbs));
    }
  }, []);


  useEffect(() => {
    if (navigationItem && navigationItem.length > 0) {
      const updatedBreadcrumbs = navigationItem.slice(0, -1); // All except last item
      const lastItem = navigationItem[navigationItem.length - 1]; // Last item

      setBreadcrumbs(updatedBreadcrumbs);
      setLastBreadcrumb(lastItem);

      // Store only up to the second-last item in localStorage
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedBreadcrumbs));
    }
  }, [navigationItem]);




  return (
    <Breadcrumbs aria-label="breadcrumb" separator="›">
    {breadcrumbs.map((item, index) => (
      <Link
        key={index}
        underline="hover"
        color="inherit"
        onClick={() => {
          if (item.menuAction) {
            navigate(item.menuAction + (item.search || ""), { state: item.state });
          }
        }}
        sx={{ cursor: "pointer" }}
      >
        {item.menuName}
      </Link>
    ))}

    {/* Last breadcrumb item, separate from localStorage */}
    {lastBreadcrumb && (
      <Typography color="text.primary">{lastBreadcrumb.menuName}</Typography>
    )}
  </Breadcrumbs>
    // <Breadcrumbs aria-label="breadcrumb" separator="›">
    //   {navigationItem?.map((item, index) => {
    //     const isLastItem = index === navigationItem.length - 1;
    //     return isLastItem ? (
    //       <Typography key={index} color="text.primary">
    //         {item.menuName}
    //       </Typography>
    //     ) : (
    //       <Link
    //         key={index}
    //         underline="hover"
    //         color="inherit"
    //         onClick={() => {
    //           if (item.menuAction) {
    //             navigate(item.menuAction + (item.search || ""), { state: item.state });
    //           }
    //         }}
    //         sx={{ cursor: "pointer" }}
    //       >
    //         {item.menuName}
    //       </Link>
    //     );
    //   })}
    // </Breadcrumbs>
  );
};

export default InjectionMouldingBreadcrumbs;

